export default "https://educa21-api.launchpad.com.br";
